import ReactPhoneInput from 'react-phone-input-material-ui';
import { Box, TextField, Typography } from '@material-ui/core';
import useStyles from './CustomPhoneField.styles';

export function CustomPhoneField({
  classes = {},
  error = false,
  placeholder = '',
  country = '',
  label = '',
  disableDropdown = false,
  onlyCountries = [],
  inputProps = {},
  value,
  helperText = '',
  onChange,
  ...props
}: Props) {
  const styles = useStyles({ error });

  return (
    <Box display='flex' flexDirection='column' gridGap='0.25rem'>
      <ReactPhoneInput
        {...props}
        placeholder={placeholder}
        country={country}
        value={value}
        onlyCountries={onlyCountries}
        containerClass={styles.containerClass}
        inputClass={styles.inputClass}
        component={TextField}
        label={label}
        disableDropdown={disableDropdown}
        inputProps={inputProps}
        onChange={onChange}
      />
      {error && (
        <Typography className={styles.errorText}>{helperText}</Typography>
      )}
    </Box>
  );
}

export interface Props {
  classes?: any;
  error?: boolean;
  placeholder: string;
  country: string;
  label: string;
  disableDropdown?: boolean;
  onlyCountries: Array<string>;
  inputProps?: any;
  value: any;
  onChange: any;
  helperText?: any;
}
